function cov_1g41p4xppg() {
  var path = "/__w/code/code/js/packages/bricks/src/hooks/useMedia.ts";
  var hash = "a6d9f5a6e4227eff72154e0aa7134c517daa91e2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/hooks/useMedia.ts",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 0
        },
        end: {
          line: 28,
          column: 4
        }
      },
      "1": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 27,
          column: 6
        }
      },
      "2": {
        start: {
          line: 18,
          column: 25
        },
        end: {
          line: 18,
          column: 34
        }
      },
      "3": {
        start: {
          line: 19,
          column: 30
        },
        end: {
          line: 19,
          column: 39
        }
      },
      "4": {
        start: {
          line: 20,
          column: 27
        },
        end: {
          line: 20,
          column: 32
        }
      },
      "5": {
        start: {
          line: 23,
          column: 22
        },
        end: {
          line: 23,
          column: 31
        }
      },
      "6": {
        start: {
          line: 24,
          column: 22
        },
        end: {
          line: 24,
          column: 31
        }
      },
      "7": {
        start: {
          line: 25,
          column: 28
        },
        end: {
          line: 25,
          column: 37
        }
      },
      "8": {
        start: {
          line: 26,
          column: 33
        },
        end: {
          line: 26,
          column: 42
        }
      },
      "9": {
        start: {
          line: 30,
          column: 17
        },
        end: {
          line: 52,
          column: 1
        }
      },
      "10": {
        start: {
          line: 31,
          column: 18
        },
        end: {
          line: 31,
          column: 30
        }
      },
      "11": {
        start: {
          line: 32,
          column: 28
        },
        end: {
          line: 32,
          column: 43
        }
      },
      "12": {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 46,
          column: 14
        }
      },
      "13": {
        start: {
          line: 35,
          column: 16
        },
        end: {
          line: 35,
          column: 44
        }
      },
      "14": {
        start: {
          line: 36,
          column: 21
        },
        end: {
          line: 38,
          column: 5
        }
      },
      "15": {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 37,
          column: 30
        }
      },
      "16": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 30
        }
      },
      "17": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 26
        }
      },
      "18": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 45,
          column: 6
        }
      },
      "19": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 44,
          column: 35
        }
      },
      "20": {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 50,
          column: 3
        }
      },
      "21": {
        start: {
          line: 48,
          column: 21
        },
        end: {
          line: 48,
          column: 49
        }
      },
      "22": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 28
        }
      },
      "23": {
        start: {
          line: 51,
          column: 2
        },
        end: {
          line: 51,
          column: 15
        }
      },
      "24": {
        start: {
          line: 54,
          column: 25
        },
        end: {
          line: 73,
          column: 1
        }
      },
      "25": {
        start: {
          line: 55,
          column: 24
        },
        end: {
          line: 55,
          column: 76
        }
      },
      "26": {
        start: {
          line: 56,
          column: 19
        },
        end: {
          line: 56,
          column: 72
        }
      },
      "27": {
        start: {
          line: 58,
          column: 24
        },
        end: {
          line: 58,
          column: 96
        }
      },
      "28": {
        start: {
          line: 59,
          column: 19
        },
        end: {
          line: 61,
          column: 3
        }
      },
      "29": {
        start: {
          line: 62,
          column: 20
        },
        end: {
          line: 62,
          column: 69
        }
      },
      "30": {
        start: {
          line: 63,
          column: 25
        },
        end: {
          line: 63,
          column: 74
        }
      },
      "31": {
        start: {
          line: 64,
          column: 2
        },
        end: {
          line: 72,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 3
          }
        },
        loc: {
          start: {
            line: 16,
            column: 14
          },
          end: {
            line: 28,
            column: 3
          }
        },
        line: 16
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 18,
            column: 19
          },
          end: {
            line: 18,
            column: 20
          }
        },
        loc: {
          start: {
            line: 18,
            column: 25
          },
          end: {
            line: 18,
            column: 34
          }
        },
        line: 18
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 19,
            column: 24
          },
          end: {
            line: 19,
            column: 25
          }
        },
        loc: {
          start: {
            line: 19,
            column: 30
          },
          end: {
            line: 19,
            column: 39
          }
        },
        line: 19
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 20,
            column: 21
          },
          end: {
            line: 20,
            column: 22
          }
        },
        loc: {
          start: {
            line: 20,
            column: 27
          },
          end: {
            line: 20,
            column: 32
          }
        },
        line: 20
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 23,
            column: 16
          },
          end: {
            line: 23,
            column: 17
          }
        },
        loc: {
          start: {
            line: 23,
            column: 22
          },
          end: {
            line: 23,
            column: 31
          }
        },
        line: 23
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 24,
            column: 16
          },
          end: {
            line: 24,
            column: 17
          }
        },
        loc: {
          start: {
            line: 24,
            column: 22
          },
          end: {
            line: 24,
            column: 31
          }
        },
        line: 24
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 25,
            column: 22
          },
          end: {
            line: 25,
            column: 23
          }
        },
        loc: {
          start: {
            line: 25,
            column: 28
          },
          end: {
            line: 25,
            column: 37
          }
        },
        line: 25
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 26,
            column: 27
          },
          end: {
            line: 26,
            column: 28
          }
        },
        loc: {
          start: {
            line: 26,
            column: 33
          },
          end: {
            line: 26,
            column: 42
          }
        },
        line: 26
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 30,
            column: 17
          },
          end: {
            line: 30,
            column: 18
          }
        },
        loc: {
          start: {
            line: 30,
            column: 36
          },
          end: {
            line: 52,
            column: 1
          }
        },
        line: 30
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 34,
            column: 18
          },
          end: {
            line: 34,
            column: 19
          }
        },
        loc: {
          start: {
            line: 34,
            column: 24
          },
          end: {
            line: 46,
            column: 3
          }
        },
        line: 34
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 36,
            column: 21
          },
          end: {
            line: 36,
            column: 22
          }
        },
        loc: {
          start: {
            line: 36,
            column: 27
          },
          end: {
            line: 38,
            column: 5
          }
        },
        line: 36
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 43,
            column: 11
          },
          end: {
            line: 43,
            column: 12
          }
        },
        loc: {
          start: {
            line: 43,
            column: 17
          },
          end: {
            line: 45,
            column: 5
          }
        },
        line: 43
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 54,
            column: 25
          },
          end: {
            line: 54,
            column: 26
          }
        },
        loc: {
          start: {
            line: 54,
            column: 31
          },
          end: {
            line: 73,
            column: 1
          }
        },
        line: 54
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 15,
            column: 23
          }
        }, {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        }],
        line: 15
      },
      "1": {
        loc: {
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 47
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a6d9f5a6e4227eff72154e0aa7134c517daa91e2"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1g41p4xppg = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1g41p4xppg();

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable react-hooks/rules-of-hooks */

/*
  useMedia is a React hook that tracks the state of a CSS media query
  
  usage:
  const isMobile = useMedia('(max-width: 480px)')
  */
import { useLayoutEffect, useState, useRef } from 'react';
import { BREAKPOINTS_DICT } from '../theme/eero'; // Stub matchMedia for SSR+Jest

cov_1g41p4xppg().s[0]++;
globalThis.matchMedia = (cov_1g41p4xppg().b[0][0]++, globalThis.matchMedia) || (cov_1g41p4xppg().b[0][1]++, function () {
  cov_1g41p4xppg().f[0]++;
  cov_1g41p4xppg().s[1]++;
  return {
    addListener: function addListener() {
      cov_1g41p4xppg().f[1]++;
      cov_1g41p4xppg().s[2]++;
      return undefined;
    },
    addEventListener: function addEventListener() {
      cov_1g41p4xppg().f[2]++;
      cov_1g41p4xppg().s[3]++;
      return undefined;
    },
    dispatchEvent: function dispatchEvent() {
      cov_1g41p4xppg().f[3]++;
      cov_1g41p4xppg().s[4]++;
      return false;
    },
    matches: false,
    media: '',
    onChange: function onChange() {
      cov_1g41p4xppg().f[4]++;
      cov_1g41p4xppg().s[5]++;
      return undefined;
    },
    onchange: function onchange() {
      cov_1g41p4xppg().f[5]++;
      cov_1g41p4xppg().s[6]++;
      return undefined;
    },
    removeListener: function removeListener() {
      cov_1g41p4xppg().f[6]++;
      cov_1g41p4xppg().s[7]++;
      return undefined;
    },
    removeEventListener: function removeEventListener() {
      cov_1g41p4xppg().f[7]++;
      cov_1g41p4xppg().s[8]++;
      return undefined;
    }
  };
});
cov_1g41p4xppg().s[9]++;

var useMedia = function useMedia(query) {
  cov_1g41p4xppg().f[8]++;
  var isFirst = (cov_1g41p4xppg().s[10]++, useRef(true));

  var _ref = (cov_1g41p4xppg().s[11]++, useState(false)),
      _ref2 = _slicedToArray(_ref, 2),
      state = _ref2[0],
      setState = _ref2[1];

  cov_1g41p4xppg().s[12]++;
  useLayoutEffect(function () {
    cov_1g41p4xppg().f[9]++;
    var mql = (cov_1g41p4xppg().s[13]++, globalThis.matchMedia(query));
    cov_1g41p4xppg().s[14]++;

    var onChange = function onChange() {
      cov_1g41p4xppg().f[10]++;
      cov_1g41p4xppg().s[15]++;
      setState(!!mql.matches);
    };

    cov_1g41p4xppg().s[16]++;
    mql.addListener(onChange);
    cov_1g41p4xppg().s[17]++;
    setState(mql.matches);
    cov_1g41p4xppg().s[18]++;
    return function () {
      cov_1g41p4xppg().f[11]++;
      cov_1g41p4xppg().s[19]++;
      mql.removeListener(onChange);
    };
  }, [query]);
  cov_1g41p4xppg().s[20]++;

  if (isFirst.current) {
    cov_1g41p4xppg().b[1][0]++;
    var firstMQL = (cov_1g41p4xppg().s[21]++, globalThis.matchMedia(query));
    cov_1g41p4xppg().s[22]++;
    return firstMQL.matches;
  } else {
    cov_1g41p4xppg().b[1][1]++;
  }

  cov_1g41p4xppg().s[23]++;
  return state;
};

cov_1g41p4xppg().s[24]++;
export var useDevice = function useDevice() {
  cov_1g41p4xppg().f[12]++;
  var isSmallMobile = (cov_1g41p4xppg().s[25]++, useMedia("(max-width: ".concat(BREAKPOINTS_DICT.SM - 1, "px")));
  var isMobile = (cov_1g41p4xppg().s[26]++, useMedia("(max-width: ".concat(BREAKPOINTS_DICT.MD - 1, "px)")));
  /** @deprecated */

  var isSmallTablet = (cov_1g41p4xppg().s[27]++, useMedia("(min-width: ".concat(BREAKPOINTS_DICT.MD, "px) and (max-width: 992px)")));
  var isTablet = (cov_1g41p4xppg().s[28]++, useMedia("(min-width: ".concat(BREAKPOINTS_DICT.MD, "px) and (max-width: ").concat(BREAKPOINTS_DICT.LG - 1, "px)")));
  var isDesktop = (cov_1g41p4xppg().s[29]++, useMedia("(min-width: ".concat(BREAKPOINTS_DICT.LG, "px)")));
  var isLargeDesktop = (cov_1g41p4xppg().s[30]++, useMedia("(min-width: ".concat(BREAKPOINTS_DICT.XL, "px)")));
  cov_1g41p4xppg().s[31]++;
  return {
    isSmallMobile: isSmallMobile,
    isMobile: isMobile,

    /** @deprecated*/
    isSmallTablet: isSmallTablet,
    isTablet: isTablet,
    isDesktop: isDesktop,
    isLargeDesktop: isLargeDesktop
  };
};
export default useMedia;